import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createDepartmentRandomDateLog = (payload) => post(baseURL + url.DEPARTMENT_RANDOM_DATE_LOG, payload);
export const getDepartmentRandomDateLogDetails = (id) => get(`${baseURL + url.DEPARTMENT_RANDOM_DATE_LOG}/${id}`);
export const updateDepartmentRandomDateLog = (id, payload) => put(`${baseURL + url.DEPARTMENT_RANDOM_DATE_LOG}/${id}`, payload);
export const deleteDepartmentRandomDateLog = (id) => remove(`${baseURL + url.DEPARTMENT_RANDOM_DATE_LOG}/${id}`);
